'use memo';

import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useState } from 'react';
import { VStack } from '@/components/Layout';
import { toast } from '@/components/ui/use-toast';
import { PolicyForm, authPoliciesKeyPrefix, createInitialPolicyForm, useCreateAuthenticationPolicy } from '@/features/authentication-policy';
import { PolicySectionHeader } from '@/features/identity-policy';
import { handleApiError } from '@/lib/api/error';
import { defaultNS, useTranslation } from '@/lib/i18n';
export const Route = createFileRoute('/_staff/settings/authentication/_layout/policies/new/')({
  component: NewAuthPolicyPage
});
function NewAuthPolicyPage() {
  const {
    i18n,
    t
  } = useTranslation(defaultNS, {
    keyPrefix: authPoliciesKeyPrefix
  });
  const navigate = useNavigate();
  const createMutation = useCreateAuthenticationPolicy();
  const [errorMessage, setErrorMessage] = useState('');
  const backToList = () => navigate({
    to: '/settings/authentication/policies'
  });
  return <VStack className="w-full gap-4 px-12 py-6">
      <PolicySectionHeader iconName="ShieldCheckIcon" title={t($ => $.form.createTitle)} description={t($ => $.description)} />
      <PolicyForm initialValue={createInitialPolicyForm} isDefault={false} isSubmitting={createMutation.isPending} errorMessage={errorMessage} onCancel={() => void backToList()} onSubmit={body => {
      setErrorMessage('');
      createMutation.mutate(body, {
        onSuccess: () => {
          toast({
            description: t($ => $.toast.created)
          });
          void backToList();
        },
        onError: error => {
          setErrorMessage(handleApiError(error, {
            language: i18n.language
          }).message);
        }
      });
    }} />
    </VStack>;
}